/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Sync_TitleInputs */

const en_team_sync_title = /** @type {(inputs: Team_Sync_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project Sync`)
};

const fr_team_sync_title = /** @type {(inputs: Team_Sync_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synchronisation du projet`)
};

const de_team_sync_title = /** @type {(inputs: Team_Sync_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projektsynchronisierung`)
};

const it_team_sync_title = /** @type {(inputs: Team_Sync_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronizzazione del progetto`)
};

const ru_team_sync_title = /** @type {(inputs: Team_Sync_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Синхронизация проекта`)
};

const es_team_sync_title = /** @type {(inputs: Team_Sync_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronización de proyectos`)
};

const zh_cn2_team_sync_title = /** @type {(inputs: Team_Sync_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项目同步`)
};

const ja_team_sync_title = /** @type {(inputs: Team_Sync_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクト同期`)
};

const hi_team_sync_title = /** @type {(inputs: Team_Sync_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट सिंक`)
};

const pt_pt2_team_sync_title = /** @type {(inputs: Team_Sync_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronização de projetos`)
};

/**
* | output |
* | --- |
* | "Project Sync" |
*
* @param {Team_Sync_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_sync_title = /** @type {((inputs?: Team_Sync_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Sync_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_sync_title(inputs)
	if (locale === "de") return de_team_sync_title(inputs)
	if (locale === "it") return it_team_sync_title(inputs)
	if (locale === "ru") return ru_team_sync_title(inputs)
	if (locale === "es") return es_team_sync_title(inputs)
	if (locale === "zh-CN") return zh_cn2_team_sync_title(inputs)
	if (locale === "ja") return ja_team_sync_title(inputs)
	if (locale === "hi") return hi_team_sync_title(inputs)
	if (locale === "pt-PT") return pt_pt2_team_sync_title(inputs)
	return en_team_sync_title(inputs)
});